module.exports = __webpack_public_path__ + "static/media/logo.dc623381.svg";